import { SharedQueryParamKey } from '@ddt-web/url';

export class AnalyticEventEvaluatorUtil {
	public static transform(analyticsEvent: string): string {
		let transformedEvent = '';
		const qsSearchParams = new URLSearchParams(location.search);
		if (qsSearchParams) {
			transformedEvent = qsSearchParams.has(SharedQueryParamKey.ENGAGEMENT) ? `portfolio solution view : ${analyticsEvent}` : `self service view : ${analyticsEvent}`;
		}
		return transformedEvent;
	}
}
